<template>
  <main>
    <RouterView />
  </main>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

onMounted(() => {
  document.title = '事件上报'
})

</script>

<style>
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
